import {
    LinearProgress,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
  } from "@material-ui/core";
  import * as React from "react";
  // tslint:disable-next-line:no-empty-interface
  export interface ITableEditoraFabricantePros {
    loading: boolean;
    rows?: any[];
    columns: any[];
    
    tableProps: {
      limit: number;
      page: number;
      total: number;
    };
    handleChangePage(ev: any, page: number): void;
  }
  function TableEditoraFabricante(props: ITableEditoraFabricantePros) {
    const { loading, rows, columns, tableProps, handleChangePage } = props;
    const { limit, page, total } = tableProps;
    const getKey = () => {
      return Math.random() * 12;
    };
    
    const getCell = (header: any) => {
      return <TableCell key={getKey()}>{header.title}</TableCell>
    }
    const getCellRow = (row: any, item: any) => {
      return <TableCell key={getKey()}>{item.render(row)}</TableCell>
    }
    return (
      <div>
        {loading ? (
          <LinearProgress />
        ) : (
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  {columns.map((v) => (getCell(v)))}
                </TableRow>
              </TableHead>
              {rows && rows.length > 0 && (
                <TableBody>
                  {rows.map((row: any, index) => (
                    <TableRow key={index}>
                      {columns.map((v) => (
                        getCellRow(row, v)
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              )}
            </Table>
            <TablePagination
              component="div"
              page={page}
              count={total}
              rowsPerPage={limit}
              rowsPerPageOptions={[]}
              backIconButtonProps={{
                "aria-label": "Previous Page",
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page",
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={undefined}
            />
          </div>
        )}
      </div>
    );
  }
  export default TableEditoraFabricante;


// WEBPACK FOOTER //
// ./src/component/administration/editoraFabricante/TableEditoraFabricante.tsx